import React from "react";
import SwiperCore, { Navigation } from "swiper";
import { Swiper, SwiperSlide } from "swiper/react";
// import PropTypes from "prop-types";
import styles from "./swiper-tracks.module.scss";
import SlideTrackContainer from "../swiper-slide/slide-track-container";
import noOp from "lib/no-op";

SwiperCore.use([Navigation]);

const SwiperTracks = ({
  activeTrackId = 0,
  ubungen = [],
  _onClick = noOp(),
  _onClickPlayerNav = noOp(),
  _onSwiper = noOp(),
  _onSlideChangeTransitionEnd = noOp(),
  metadata = [],
}) => {
  return (
    <div className={styles.root}>
      <Swiper
        shortSwipes={false}
        onSwiper={(swiper) => {
          _onSwiper(swiper);
        }}
        onSlideChangeTransitionEnd={(swiper) => {
          _onSlideChangeTransitionEnd(swiper);
        }}
        onClick={(s) => {
          const { activeIndex } = s;
          const { isFreemium } = ubungen[activeIndex];
          if (!isFreemium) {
            _onClick(s);
          }
        }}
        className={styles.swiperContainer}
        spaceBetween={0}
        slidesPerView={1}
        navigation
        onSlideChange={(swiper) => {}}
        simulateTouch={true}
        noSwiping={true}
        noSwipingClass={"swiper-no-swiping"}
      >
        {ubungen.map((slide, index) => (
          <SwiperSlide key={index} className={styles.sliderContainer}>
            <SlideTrackContainer
              nrTracks={ubungen.length}
              ubung={slide}
              activeTrackId={activeTrackId}
              handlerOnClick={_onClick}
              _onClickPlayerNav={_onClickPlayerNav}
              metadata={metadata}
            />
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  );
};

SwiperTracks.defaultProps = {
  ubungen: [],
};

SwiperTracks.propTypes = {};

export default SwiperTracks;
